<template>
  <div class="launch">
    <div class="launch-info">
      <p><i>Create your customized e-commerce experience...</i></p>
      <h1>Launch in 1 day for free!</h1>
    </div>
    <div class="cta-btn-launch">
      <a href="https://console.helixpay.ph/#/login" class="launch-signup">
        Sign-up for Free
      </a>
      <a
        href="https://dashboard.meetbit.io/meeting/HelixPay"
        class="launch-schedule"
      >
        Schedule Demo
      </a>
    </div>

    <img src="/img/blur-circle.svg" class="blur1" alt="" />
    <img src="/img/blur-circle.svg" class="blur2" alt="" />
    <img src="/img/blur-circle.svg" class="blur3" alt="" />
  </div>
</template>

<style scoped>
.launch {
  width: 100%;
  margin: auto;
  height: inherit;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 5rem 0;

  background-color: black;
}

.launch-info {
  display: grid;
  width: 35rem;
  margin: auto;
  z-index: 9;
  position: relative;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.launch-info p {
  color: white;
  opacity: 0.6;
  font-weight: 500;
  font-size: 1.3rem;
}

.launch h1 {
  width: 100%;
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding-top: 1rem;
  text-align: center;
  line-height: 1.5;
}

.cta-btn-launch {
  z-index: 9;
  display: flex;
  text-align: center;
  margin: auto;
  padding-top: 2rem;
  width: 30rem;
}

.launch-signup {
  z-index: 9;
  width: 100%;
  background-color: #25a4e1;
  color: black;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.launch-schedule {
  z-index: 9;
  width: 100%;
  background-color: #9affe1;
  color: black;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.launch-signup:hover {
  color: black;
  background-color: #2094ca;
}

.launch-schedule:hover {
  color: black;
  background-color: #74e2c1;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ MAIN CIRCLE */

.blur1 {
  width: 45%;
  right: -15%;
  bottom: 5%;
  z-index: 8;
  position: absolute;
  pointer-events: none;
  animation: move 150s ease-out infinite;
}

@keyframes move {
  0% {
    width: 15%;
    right: -20%;
  }
  100% {
    width: 25%;
    right: 100%;
    bottom: 70%;
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Blur 2 */

.blur2 {
  opacity: 0.5;
  width: 15%;
  left: 1%;
  bottom: 1%;
  z-index: 7;
  position: absolute;
  pointer-events: none;
  animation: right 100s ease-out infinite;
}

@keyframes right {
  0% {
    width: 15%;
    left: -15%;
    bottom: 1%;
  }
  100% {
    width: 25%;
    left: 100%;
    bottom: 40%;
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Blur 3 */

.blur3 {
  opacity: 0.5;
  width: 5%;
  left: 1%;
  top: -10%;
  z-index: 6;
  position: absolute;
  pointer-events: none;
  animation: lower 70s ease-out infinite;
}

@keyframes lower {
  0% {
    width: 5%;
    left: -15%;
    top: -10%;
  }
  100% {
    width: 10%;
    left: 100%;
    top: 50%;
  }
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

@media only screen and (max-width: 650px) {
  .launch {
    width: 100%;
  }

  .launch-info {
    width: 90%;
    margin: auto;
  }

  .launch h1 {
    font-size: 1.3rem;
  }

  .cta-btn-launch {
    display: grid;
    text-align: center;
    margin: auto;
    width: 60%;
  }

  .launch-signup {
    font-size: 1rem;
  }

  .launch-schedule {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .launch-info p {
    font-size: 1rem;
  }
}
</style>
